import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import * as _ from 'lodash';
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from '../../environments/environment';
import { AlertConfig, AlertConfirmPopupService, AlertPromiseResolveType } from '../common/alert-confirm-popup';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, BULK_UPLOAD, TRANSFER_NUMBER_CONSTANTS, LINE_IDENTIFIER, ENTITLEMENT_ACTIVITYNAMES, RATEPLANSERVICE, PILOT_CHANGE_SERVICE_ORGS } from '../common/core/common.constants';
import { ErrorMessageService } from './error-message.service';
import { HttpCacheService } from './http-cache.service';
import { AuthHttpService } from './http-wrapper.service';
import { RequestsBulkPortin, MultiLineBulkPortinHeaders } from '../common/models/data.model';
import { LoaderService } from './loader.service';
import { EntitlementService } from './entitlement.service';
import { Router } from '@angular/router';
import { HelperUtilityService } from './helper-utility.service';
import { WindowServiceService } from './window-service.service';
import { EnvironmentDetailsService } from './environment-details.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ContentService } from './content.service';
@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  body: any;
  authToken: any;
  orgID: any;
  resObject: any = { errorCode: '', errorMessage: '', errorType: '' };
  homeSearchText = '';
  IsErrorShown = false;

  config: AlertConfig;
  _helperUtilSvc: HelperUtilityService;
  _loaderSvc: LoaderService;
  entitlementSvc: EntitlementService;
  _cacheSvc: HttpCacheService;
  errMsgSvc: ErrorMessageService;
  alertModal: AlertConfirmPopupService;
  _router: Router;
  _windowService: WindowServiceService;
  _envSvc: EnvironmentDetailsService;
  httpClient: AuthHttpService;
  changeActivityForLH_User$ = new Subject();
  
  public banner2FA = new BehaviorSubject(false);
  public multiBanner = new BehaviorSubject(false);
  public restrictionBanner = new BehaviorSubject(false);
  public banner2FAFailure = new BehaviorSubject(false);

  portInPSTDate: any;
  constructor( private injector : Injector ) {
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.entitlementSvc = this.injector.get<EntitlementService>(EntitlementService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this.errMsgSvc = this.injector.get<ErrorMessageService>(ErrorMessageService);
    this.alertModal = this.injector.get<AlertConfirmPopupService>(AlertConfirmPopupService);
    this._router = this.injector.get<Router>(Router);
    this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
    this._envSvc = this.injector.get<EnvironmentDetailsService>(EnvironmentDetailsService);
    this.httpClient = this.injector.get<AuthHttpService>(AuthHttpService);
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID =  this._helperUtilSvc.getOrgID();
  }

  setHeaders() {

    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-Org': this.orgID,
          'transactionID':  this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        },
      ),
    };
  }

  public getCookie(name: string) {
    const value = '; ' + document.cookie;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
  }

  // this method will make a post call to logg requested
  // component name, method name, service name, request object,
  // response object and any other message.

  public dateFormatter(selector) {
    const date = selector.split('-');
    return (date[0] + '/' + date[1] + '/' + (date[2].substr(2, 2)));
  }

  getContentDataFromSession() {
    return JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CONTENT));
  }

  errorHandling(err: any, type?: any) {
    let errorCodeMsg;
    let errorMessageMsg;

    if (!isNullOrUndefined(err) && !isNullOrUndefined(err.error)) {

      if (!isNullOrUndefined(err.error.errors) && !isNullOrUndefined(err.error.errors.error)) {
        errorCodeMsg = (!isNullOrUndefined(err.error.errors)) ? err.error.errors.error[0].code : '';
        errorMessageMsg = (!isNullOrUndefined(err.error.errors)) ? err.error.errors.error[0].userMessage : '';
      } else if (!isNullOrUndefined(err.error.error)) {
        errorCodeMsg = (!isNullOrUndefined(err.error.error)) ? err.error.error[0].code : '';
        errorMessageMsg = (!isNullOrUndefined(err.error.error)) ? err.error.error[0].userMessage : '';
      } else if (!isNullOrUndefined(err.error)) {
        if (!isNullOrUndefined(err.error[0]) && !isNullOrUndefined(err.error[0].code)) {
          errorCodeMsg = (!isNullOrUndefined(err.error)) ? err.error[0].code : '';
          errorMessageMsg = (!isNullOrUndefined(err.error)) ? err.error[0].userMessage : '';
          // tslint:disable-next-line:max-line-length
        } else if (!isNullOrUndefined(err.error[0]) && isNullOrUndefined(err.error[0].code)
          && !isNullOrUndefined(err.status)) {
          errorCodeMsg = (!isNullOrUndefined(err.error)) ? err.status : '';
          errorMessageMsg = (!isNullOrUndefined(err.error)) ? err.statusText : '';
        } else{
          errorCodeMsg = err.error.code || '';
          errorMessageMsg = err.error.userMessage || err.error.message || '';
        }
      }
    } else if (!isNullOrUndefined(err) && isNullOrUndefined(err.error) &&
      !isNullOrUndefined(err.code) && !isNullOrUndefined(err.userMessage)) {
      errorCodeMsg = (!isNullOrUndefined(err)) ? err.code : '';
      errorMessageMsg = (!isNullOrUndefined(err)) ? err.userMessage : '';
    } else {
      errorCodeMsg = COMMON_CONSTANTS.TOKEN_ERROR_CODE_1001;
      errorMessageMsg = COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    }

    this.resObject.errorCode = errorCodeMsg;
    this.resObject.errorMessage = errorMessageMsg;
    this.errMsgSvc.serviceError(this.resObject, true);
    let errorMsg;
    if (!isNullOrUndefined(this.errMsgSvc.errorAlert.message)) {
      if (!isNullOrUndefined(this.errMsgSvc.errorAlert.message.errorMessage) &&
        !isNullOrUndefined(this.errMsgSvc.errorAlert.message.errorMessage.message) &&
        !isNullOrUndefined(this.errMsgSvc.errorAlert.message.errorMessage.message.errorMessage)) {
        errorMsg = this.errMsgSvc.errorAlert.message.errorMessage.message.errorMessage;
      } else {
        errorMsg = this.errMsgSvc.errorAlert.message.errorMessage;
      }

      if (!isNullOrUndefined(type) && type === COMMON_CONSTANTS.INLINE_TXT) {
        return errorMsg;
      } else {
        this.config = {
          data: {
            title: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
            iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
            message: errorMsg,
            btnNo: false,
            class: {
              btnOk: COMMON_CONSTANTS.TEST,
            },
          },
        };
        //Submit API failure error popup scenario for any errors
        if (!isNullOrUndefined(err) && err.status !== 200 && errorCodeMsg !="ERR_INVALID_COOKIE") {
          this.config = {
            data: {
              title: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
              iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
              message: COMMON_CONSTANTS.SERVER_ERROR_MSG,
              btnNo: false,
              class: {
                btnOk: COMMON_CONSTANTS.TEST,
              },
            },
          };

        }

        this.alertModal.openModal(this.config).result.then((res: AlertPromiseResolveType) => undefined);
      }
    } else if (!isNullOrUndefined(err) && err.message === MANAGE_LINE_CONST.BAN_NUMBER_INVALID) {
      this.config = {
        data: {
          title: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
          iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
          message: err.message,
          btnNo: false,
          class: {
            btnOk: COMMON_CONSTANTS.TEST,
          },
        },
      };
    }

  }

  replaceParams(endPoint, params) {
    if (_.isString(endPoint)) {
      if (!_.isNull(params)) {
        _.forEach(params, function(val, key) {
          endPoint = endPoint.replace('[' + key + ']', val); // First look for optional params
          endPoint = endPoint.replace('{' + key + '}', val);
        });
      }
      endPoint = endPoint.replace(/(\[[^\[]*\])/g, ''); // Replace undefined optional param holders
      // endPoint = endPoint.replace(/\/\//, '/'); // Replace '//' if any with '/'
      endPoint = endPoint.replace(/(\/)$/, ''); // Remove trailing '/'
    }
    return endPoint;
  }

  nextButtonEnable(){

    let currentServiceList=!isNullOrUndefined(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST))?JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST)):'';
    let count=0;
    let isServiceChange: boolean = false;
    if(!isNullOrUndefined(currentServiceList)){
      _.each(currentServiceList, (item) => {
        if((!item.current && item.isSelected) || (item.current && !item.isSelected)){
          count++;
        }
      })
    }
    if(count == 0 && !(Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.IS_PLAN_CHANGE))))){
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE,isServiceChange);
      return true;
    }else{
      if(count==0 && Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.IS_PLAN_CHANGE)))){
        this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE,isServiceChange);
      }else{
        isServiceChange = true;
        this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE,isServiceChange);
      }
      return false;
    }

  }

  convertTo24H(time_str) {
    // Convert a string like 10:05:23 PM to 24h format, returns like 22:05:23
    var time = time_str.match(/(\d+):(\d+):(\d+) (\w)/);
    var hours = Number(time[1]);
    var minutes = Number(time[2]);
    var seconds = Number(time[3]);
    var meridian = time[4].toLowerCase();

    if (meridian == 'p' && hours < 12) {
      hours += 12;
    }
    else if (meridian == 'a' && hours == 12) {
      hours -= 12;
    }

    let pstTime = hours + ":" + minutes + ":" + seconds;

    return pstTime;
  }

  getPortInDateTime(portInDate, portInTime){

    let dateArray = portInDate?.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
    if (!isNullOrUndefined(dateArray) && !isNullOrUndefined(dateArray.length) && dateArray.length!== 0
      && !isNullOrUndefined(dateArray[0] && !isNullOrUndefined(dateArray[1]) && !isNullOrUndefined(dateArray[2]))) {
        dateArray =  dateArray[2] + "-" + dateArray[0].toString().padStart(2, '0') + "-" + dateArray[1];
      }
    if (portInTime && portInTime.length != 0) {
      let dateTimeString = dateArray + " " + portInTime + " " + "UTC";
      dateArray = new Date(dateTimeString).toISOString();
    } else {
       dateArray = dateArray + COMMON_CONSTANTS.DEFAULT_PORT_IN_TIMEZONE;
    }

    return dateArray;
  }

  updatedPortinBulkRequestHeader(portLines) {
    const multiLineBulkPortinHeaders = new MultiLineBulkPortinHeaders();
    for (let index = 0; index < portLines.length; index++) {
      const requestsBulkPortin = new RequestsBulkPortin();

      requestsBulkPortin.logonId = _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)), 'logonId', '');
      requestsBulkPortin.orgId = this._helperUtilSvc.getOrgID();
      requestsBulkPortin.email = _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)), 'logonId', '');
      requestsBulkPortin.billingAccountNumber = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY); // BAN
      requestsBulkPortin.portInDateTime = this.getPortInDateTime(portLines[index][BULK_UPLOAD.PORT_DATE_TXT], portLines[index][BULK_UPLOAD.PORT_START_TIME_TXT]);
      requestsBulkPortin.msisdn = portLines[index][BULK_UPLOAD.MSISDN_NUMBER_TXT];         // T-Mobile MSISDN     data[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]
      requestsBulkPortin.newMsisdn = portLines[index][BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]; // Number to Transfer
      requestsBulkPortin.reasonCode = TRANSFER_NUMBER_CONSTANTS.REASON_CODE_PR;
      requestsBulkPortin.ospAccountPassword = portLines[index][BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD]; // Account Pin or Password
      requestsBulkPortin.ospAccount = portLines[index][BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER]; // Carrier Account Number
      multiLineBulkPortinHeaders.requests[index] = requestsBulkPortin;
    }
    return multiLineBulkPortinHeaders;
  }

  HandleAPIError(serverMsg) {
    this.config = {
      data: {
        title: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
        iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
        message: serverMsg,
        btnNo: false,
        class: {
          btnOk: COMMON_CONSTANTS.TEST,
        },
      },
    };
    this.alertModal.openModal(this.config).result.then((res: AlertPromiseResolveType) => undefined);
  }

  entitlementActivitiesInit() {
    return {
      sidenavLinks: {
        manageLines: false,
        transactions: false,
        manageUsers: false,
        shopCatalog: false,
        upgrades: false,
        orderHistory: false,
        cart: false,
        overview: false,
        analyzeBill: false,
        reports: false,
        settings: false,
        approvalDashboard: false,
        viewDashboardSingleBan: false,
        viewDashboardMultiBan: false
      },
      single: {
        simSwap: false,
        suspend: false,
        restore: false,
        changeNumber: false,
        portIn: false,
        lineIdentifier: false,
        changeService: false,
        changeRatePlan: false,
        cancelSubscriber: false,
        managePairing: false,
        verifyAffiliation: false,
        manageSimSwapBlock: false,
        managePortOutProtection: false,
        simLockUnlock:false,
        manageTpopSingle:false,
      },
      bulk: {
        simSwap: false,
        suspend: false,
        restore: false,
        changeNumber: false,
        portIn: false,
        lineIdentifier: false,
        cancelSubscriber: false,
        changeService: false,
        managePairing: false,
        strategicPortIn: false,
        manageSimSwapBlock: false,
        manageSimSwapBan: false,
        managePortOutProtection: false,
        manageTpopBan:false,
        manageTpopBulk:false
      },
      transactionHistory: false,
      upgrade: false,
      addLine: false,
      addAccountName: false,
      accountDetail: false,
      lineDetails: false,
      usageDetails: false,
      banUsageDetails: false,
      makePayments: false,
      planAndServices: false,
      partnerSubscriptionRedemption: false,
      lhUserNotifictions:false
    }
  }

  findLighthouse_AccMngmnt_Activities(data){
    let isRestrictedPage: boolean = true;
    this._loaderSvc.stop();
    const entitlementActivities = this.entitlementActivitiesInit();
    if (!isNullOrUndefined(data) && !isNullOrUndefined(data.responseList)) {
      data.responseList.forEach((rolesElement) => {

        switch (rolesElement.activityName) {
          case ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE: entitlementActivities.single.simSwap = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE: entitlementActivities.single.changeNumber = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE: entitlementActivities.single.restore = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE: entitlementActivities.single.suspend = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK: entitlementActivities.bulk.simSwap = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK: entitlementActivities.bulk.changeNumber = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK: entitlementActivities.bulk.restore = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK: entitlementActivities.bulk.suspend = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.PORT_IN: entitlementActivities.bulk.portIn = true; entitlementActivities.single.portIn = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY:
          case ENTITLEMENT_ACTIVITYNAMES.TRANSACTION_HISTORY_LH:
            entitlementActivities.transactionHistory = entitlementActivities.sidenavLinks.transactions = true;
            isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER: entitlementActivities.single.lineIdentifier = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER_BULK: entitlementActivities.bulk.lineIdentifier = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_SINGLE: entitlementActivities.single.changeService = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICE_BULK:
            // Bulk Change Service is only available during Pilot Project for participating ORGs
            entitlementActivities.bulk.changeService = PILOT_CHANGE_SERVICE_ORGS.indexOf(this._helperUtilSvc.getOrgID()) != -1;
            isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.UPGRADE: entitlementActivities.upgrade
                                                    = entitlementActivities.sidenavLinks.upgrades = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.ADD_LINE: entitlementActivities.addLine = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.ADD_ACCOUNT_FRIENDLY_NAME: entitlementActivities.addAccountName = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN:
            if(rolesElement.resourceTypeName == ENTITLEMENT_ACTIVITYNAMES.LINE_OF_SERVICE)
            {  entitlementActivities.single.changeRatePlan = true; }
            isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE:
             entitlementActivities.single.cancelSubscriber = true;
            isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CANCEL_SERVICE_BULK:
             entitlementActivities.bulk.cancelSubscriber = true;
            isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_SINGLE:
              entitlementActivities.single.managePairing = true;
              break;
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PAIRING_BULK:
              entitlementActivities.bulk.managePairing = true;
              break;
          case ENTITLEMENT_ACTIVITYNAMES.STRATEGIC_PORT_IN_BULK:
              entitlementActivities.bulk.strategicPortIn = true;
              break;
          case ENTITLEMENT_ACTIVITYNAMES.VERIFY_AFFILIATION:
              entitlementActivities.single.verifyAffiliation = true;
              break;
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PORT_OUT_PROTECTION_SINGLE:
              entitlementActivities.single.managePortOutProtection = true;
              break;
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_PORT_OUT_PROTECTION_BULK:
              entitlementActivities.bulk.managePortOutProtection = true;
              break;              
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_SWAP_BLOCK_SINGLE:
            entitlementActivities.single.manageSimSwapBlock = true;
            break
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_SWAP_BLOCK_BULK:
            entitlementActivities.bulk.manageSimSwapBlock = true;
            break
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_SWAP_BLOCK_UNBLOCK_BAN:
            entitlementActivities.bulk.manageSimSwapBan = true;
            break
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_SIM_LOCK_UNLOCK_SINGLE:
            entitlementActivities.single.simLockUnlock = true;
            break
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_TPOP_SINGLE:
            entitlementActivities.single.manageTpopSingle = true; 
            break          
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_TPOP_BULK:
            entitlementActivities.bulk.manageTpopBulk = true;
            break
          // Check what sidenav links user has access to
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_LINES: entitlementActivities.sidenavLinks.manageLines = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.MANAGE_USERS: entitlementActivities.sidenavLinks.manageUsers = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SHOP_CATALOG: entitlementActivities.sidenavLinks.shopCatalog = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.ORDER_HISTORY: entitlementActivities.sidenavLinks.orderHistory = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CART: entitlementActivities.sidenavLinks.cart = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.OVERVIEW: entitlementActivities.sidenavLinks.overview = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.ANALYZE_BILL: entitlementActivities.sidenavLinks.analyzeBill = entitlementActivities.sidenavLinks.reports
                                                                                                      = true; isRestrictedPage = false;
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SETTINGS: entitlementActivities.sidenavLinks.settings = true; isRestrictedPage = false;
            break;
            case ENTITLEMENT_ACTIVITYNAMES.APPROVAL_DASHBOARD: entitlementActivities.sidenavLinks.approvalDashboard = true; isRestrictedPage = false;

          //for account detail Tab
          case ENTITLEMENT_ACTIVITYNAMES.ACCOUNT_DETAIL: entitlementActivities.accountDetail = true; isRestrictedPage = false;
          break;

          case ENTITLEMENT_ACTIVITYNAMES.LINE_DETAILS: entitlementActivities.lineDetails = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.IOT_LINE_DETAILS: entitlementActivities.lineDetails = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.VIEW_BAN_USAGE: entitlementActivities.banUsageDetails = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.USAGE_DETAILS: entitlementActivities.usageDetails = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.MAKE_PAYMENTS: entitlementActivities.makePayments = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.VIEW_DASHBOARD_SINGLEBAN: entitlementActivities.sidenavLinks.viewDashboardSingleBan = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.VIEW_DASHBOARD_MULTIBAN: entitlementActivities.sidenavLinks.viewDashboardMultiBan = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.PARTNER_SUBSCRIPTION_REDEMPTION: entitlementActivities.partnerSubscriptionRedemption = true; isRestrictedPage = false;
          break;
          case ENTITLEMENT_ACTIVITYNAMES.LH_USER_NOTIFICATIONS: entitlementActivities.lhUserNotifictions = true; isRestrictedPage = false;
          break;
        }
      });


      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.ENTITLEMENT_ACTIVITIES, btoa(JSON.stringify(entitlementActivities)));
      this.entitlementSvc.isEntitlementActivityChanged.next(true);
    }
    if (isRestrictedPage) {
      this._router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
      return false;
    }
  }

  setApprovalActivities(activities) {
    let approvalFlags = [];
    if (!isNullOrUndefined(activities)) {
      let i = 0;
      activities.forEach((rolesElement) => {
        switch (rolesElement.activityName) {
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGENUMBER_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGENUMBER_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_RESTORE_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_RESTORE_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_SUSPEND_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_SUSPEND_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_SIM_SWAP_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_SIM_SWAP_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_SERVICES:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGE_SERVICE_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGE_SERVICE_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN:
            if(rolesElement.resourceTypeName === ENTITLEMENT_ACTIVITYNAMES.LINE_OF_SERVICE){
              if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
                approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGE_RATE_PLAN_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
              } else {
                approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_CHANGE_RATE_PLAN_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
              }
            }
            break;
          case ENTITLEMENT_ACTIVITYNAMES.PORT_IN:
            if (rolesElement.isApprovalRequired === COMMON_CONSTANTS.COUNT_ONE) {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_PORT_IN_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ONE }; i++;
            } else {
              approvalFlags[i] = { FlagName: COMMON_CONSTANTS.IS_PORT_IN_APPROVAL, FlagValue: COMMON_CONSTANTS.DIGITS.ZERO }; i++;
            }
            break;
        }
      });
      this._cacheSvc.putInSessionStoarage("approvalFlags", JSON.stringify(approvalFlags));
    }
  }

  modifyActionTypeValues(actionType, suspendLines, activeLines) {
    if (!isNullOrUndefined(actionType)) {
      _.forEach(actionType, (item) => {
        let lines = item.actionTypeName === MANAGE_LINE_CONST.RESTORE_CTA_TXT ? suspendLines : activeLines;
        lines = !isNullOrUndefined(lines) ? lines.length : COMMON_CONSTANTS.DIGITS.ZERO;
        let changeNumberActivity = ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_SINGLE;
        let changeSimActivity = ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_SINGLE;
        let restoreActivity = ENTITLEMENT_ACTIVITYNAMES.RESTORE_SINGLE;
        let suspendActivity = ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE;
        let transferActivity = ENTITLEMENT_ACTIVITYNAMES.TRANSFER_NUMBER;
        let lineIdentifierActivity = ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER;
        if (lines > COMMON_CONSTANTS.LIMIT) {
          changeNumberActivity = ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK;
          changeSimActivity = ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK;
          restoreActivity = ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK;
          suspendActivity = ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK;
          transferActivity = ENTITLEMENT_ACTIVITYNAMES.TRANSFER_NUMBER;
          lineIdentifierActivity = ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER_BULK;
        }
        switch (item.actionTypeName) {
          case COMMON_CONSTANTS.ACTION_HYPERLINK.CHANGE_SIM:
          case MANAGE_LINE_CONST.SIM_CHANGE_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(changeSimActivity);
            break;
          case MANAGE_LINE_CONST.CHANGE_NUMBER_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(changeNumberActivity);
            break;
          case COMMON_CONSTANTS.ACTION_HYPERLINK.RESTORE_LINE:
          case MANAGE_LINE_CONST.RESTORE_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(restoreActivity);
            break;
          case COMMON_CONSTANTS.ACTION_HYPERLINK.SUSPEND_LINE:
          case MANAGE_LINE_CONST.SUSPEND_LINES_CTA_TXT:
          case MANAGE_LINE_CONST.SUSPEND_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(suspendActivity);
            break;
          case MANAGE_LINE_CONST.TRANSFER_NUMBERS_CTA_TXT:
          case MANAGE_LINE_CONST.TRANSFER_NUMBER_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(transferActivity);
            break;
          case MANAGE_LINE_CONST.UPDATE_LINE_IDENTIFIER_CTA_TXT:
            item.actionDisabled = this.isReadOnly_Iam_UserActivity(lineIdentifierActivity);
        }
      });
    }
  }

  isReadOnly_AhubCare_UserActivity(activityName) {
    /**this function will return true if activity come as readonly */
    const enableAhubFlow = environment.ENABLE_AHUB_FLOW;
    const isCareUser = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY ? true : false;

    if (enableAhubFlow && isCareUser) {
      const activities = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACTIVITIES_DATA) ? JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACTIVITIES_DATA)) : null;
      if (!isNullOrUndefined(activities) && !isNullOrUndefined(activities.responseList)) {
        //activities.responseList.forEach((rolesElement) => {
          const activityObject = _.find(activities.responseList, (item) => { return item.activityName === activityName });
          if (!isNullOrUndefined(activityObject)) {
            return this.checkingReadOnlyFlag(activityObject);
          } else {
            return true;
          }
        //});

      }
    } else {
      return false;
    }
  }

  isReadOnly_Iam_UserActivity(activityName) {
    /**this function will return true if activity come as readonly */
    const enableAhubFlow = environment.ENABLE_AHUB_FLOW;
    const isIamUser = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) === COMMON_CONSTANTS.IAM_KEY ? true : false;

    if (enableAhubFlow && isIamUser) {
      const activities = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACTIVITIES_DATA) ? JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACTIVITIES_DATA)) : null;
      if (!isNullOrUndefined(activities) && !isNullOrUndefined(activities.responseList)) {
          const activityObject = _.find(activities.responseList, (item) => { return item.activityName === activityName });
          if (!isNullOrUndefined(activityObject)) {
            return this.checkingReadOnlyFlag(activityObject);
          } else {
            return true;
          }
      }
    } else {
        return false;   
    }
  }

  checkingReadOnlyFlag(activityObject){
    if (activityObject.readOnlyFlag == COMMON_CONSTANTS.DIGITS.ONE) {
      return true;
    } else {
      return false;
    }      
  }


  redirectToOktaPopup() {
    this.config = {
      data: {
        title: COMMON_CONSTANTS.ALERT_TYPES.ACCESS_TOKEN_EXPIRED,
        iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
        message: COMMON_CONSTANTS.ALERT_TYPES.REDIRECT_TO_LOGIN_MSG,
        btnNo: false,
        class: {
          btnOk: COMMON_CONSTANTS.TEST,
        },
      },
    };
    if (this.alertModal.isModalOpen === false) {
      this.alertModal.openModal(this.config).result.then((res: AlertPromiseResolveType) => undefined);
    }
  }

  navigateToDashboard() {
    let navigationUri ;
    let orgId = this._helperUtilSvc.getOrgID();
    let userId = this._helperUtilSvc.getUserId();

    let authType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY
  ? COMMON_CONSTANTS.OKTA_KEY : COMMON_CONSTANTS.IAM_KEY;
    let isEndUser = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLE) === COMMON_CONSTANTS.END_USER ? true : false;

    if (isEndUser) {
      navigationUri = environment.DASHBOARD_URL_ENDUSER + '?pid='+btoa('orgId='+orgId+'&userId='+userId+'&IDPType='+COMMON_CONSTANTS.IAM_KEY);
    } else if (authType !== COMMON_CONSTANTS.IAM_KEY) {
      navigationUri = environment.DASHBOARD_URL_OKTA + '?pid='+btoa('orgId='+orgId+'&userId='+userId+'&IDPType='+COMMON_CONSTANTS.OKTA_KEY);
    } else {
      navigationUri = environment.DASHBOARD_URL_IAM + '?pid='+btoa('orgId='+orgId+'&userId='+userId+'&IDPType='+COMMON_CONSTANTS.IAM_KEY);
    }
    this._windowService.redirectTo(navigationUri);
  }

  createConfigModel() {
    const configModel = [];
    const configurationResponse = JSON.parse(this._cacheSvc.getFromSessionStorage(LINE_IDENTIFIER.CONFIG_RESPONSE));
    if (!isNullOrUndefined(configurationResponse && configurationResponse.orgConfigValues)) {
      const configResult = configurationResponse.orgConfigValues;
      for (const result of configResult) {
        if (!isNullOrUndefined(result) && (result.configName === LINE_IDENTIFIER.CONFIG_UDFID1 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID2 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID3 ||
          (environment.ENABLE_CUP_NOREGRETS_UDF && (result.configName === LINE_IDENTIFIER.CONFIG_UDFID4 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID5)) ||
          (environment.ENABLE_DH_UDF && (result.configName === LINE_IDENTIFIER.CONFIG_UDFID6)) || 
          (environment.ENABLE_UDF_AHUB_2 && (result.configName === LINE_IDENTIFIER.CONFIG_UDFID7 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID8 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID9 || result.configName === LINE_IDENTIFIER.CONFIG_UDFID10)))) {
          const udfObject = {};
          if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID1) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID1;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel.length > 1 ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF1;
          } else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID2) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID2;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel.length > 1 ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF2;
          } else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID3) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID3;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF3;
          } else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID4) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID4;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF4;
          } else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID5) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID5;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF5;
          } else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID6) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID6;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF6;
          }else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID7) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID7;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF7;
          }else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID8) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID8;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF8;
          }else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID9) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID9;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF9;
          }else if (result.configName === LINE_IDENTIFIER.CONFIG_UDFID10) {
            udfObject[LINE_IDENTIFIER.CONFIG_NAME] = LINE_IDENTIFIER.CONFIG_UDFID10;
            const conifgLevel = result.configValue ? result.configValue.split(COMMON_CONSTANTS.SYMBOLS.COLON) : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_LABEL] = conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ZERO] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_DESC] = conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] ? conifgLevel[COMMON_CONSTANTS.DIGITS.ONE] : COMMON_CONSTANTS.STRING_EMPTY;
            udfObject[LINE_IDENTIFIER.CONFIG_TYPE] = environment.ENABLE_UDF_AHUB_2 ? result?.configType : null;
            udfObject[LINE_IDENTIFIER.CONFIG_PICKLIST_VALUE] = environment.ENABLE_UDF_AHUB_2 ? result?.pickListValue : null;
            udfObject[LINE_IDENTIFIER.CONFIG_KEY] = LINE_IDENTIFIER.CONFIG_UDF10;
          }
          udfObject[LINE_IDENTIFIER.CONFIG_VALUE] = COMMON_CONSTANTS.STRING_EMPTY;
          configModel.push(udfObject);
        }
      }
      const primeUDFIDObj = configResult.find((x) => x.configName === LINE_IDENTIFIER.CONFIG_UDFIDPRIMARY);
      if(!isNullOrUndefined(primeUDFIDObj)){
        this._cacheSvc.putInSessionStoarage(LINE_IDENTIFIER.PRIMARY_UDF, JSON.stringify(primeUDFIDObj));
      }

      if (!isNullOrUndefined(primeUDFIDObj) && !isNullOrUndefined(primeUDFIDObj.configValue)) {
        const index = configModel.findIndex((x) => x.configName === primeUDFIDObj.configValue);
        configModel.unshift(configModel.splice(index, 1)[0]);
      }
    }
    return configModel;
    }

    IsEndUser() {
      if (environment.ENABLE_END_USER) {
        return !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ENABLE_ENDUSER)) ?
          this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ENABLE_ENDUSER) :
          false;
      }
      return false;
    }

  redirectToRoleChooser(){
    const userId = this._helperUtilSvc.getUserId();
    const orgId = this._helperUtilSvc.getOrgID();
    const authType = this._helperUtilSvc.getAuthType();
    const roleType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLE);
    const redirectTo = COMMON_CONSTANTS.ROLE_CHOOSER;
    let queryParamStoredInSession = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.QUERY_PARAM_UID);
    let returnURI = environment.iamRedirectUrl + '?' +   COMMON_CONSTANTS.UID_KEY + '=' + queryParamStoredInSession;

    let globalSettingsURI = 'userId=' + btoa(userId) + '&orgId=' + btoa(orgId) + '&userRole=' + btoa(roleType) +
                           '&redirectTo=' + redirectTo + '&returnURI=' + btoa(returnURI) + '&authType=' + authType;
    this._cacheSvc.clearSessionStorage();  // insure to clear session so that roles api load again for that user
    this._windowService.redirectTo(environment.MANAGE_USERS_URL + globalSettingsURI);
  }

  navigateToOrgSearch(){
    const authType = this._helperUtilSvc.getAuthType();

    if (authType !== COMMON_CONSTANTS.IAM_KEY) {
      this._cacheSvc.clearSessionStorage();  // insure to clear session so that new org can be set in am app
      this._windowService.redirectTo(environment.ORG_HOME_URL_OKTA);
    }
  }

  userMgmtRestrictedPage() {
    this._cacheSvc.clearSessionStorage();  // insure to clear session so that roles api load again for that user
    this._windowService.redirectTo(environment.USER_MANAGEMENT + COMMON_CONSTANTS.RESTRICTED_ACCESS);
  }

  navigateToRestrictedPage() {
    this._router.navigate(['/apps/tfb_acctmgmt/account-management/restrict-page']);
  }

  setValueOrDefault(value, defaultValue) {
    if (value === null || value === undefined) {
      return defaultValue;
    }
    return value;
  }

  setValueIfConditionElseDefault(condition, value, defaultValue) {
    if (condition) {
      return value
    }
    return defaultValue;
  }
  isNotNullOrUndefined(value){
    if(value!== null && value !== undefined){
      return true;
    }
    return false;
  }
  showValidateErrorMessage(error: any) {
    let message;

    if (!!error && !!error?.error && error?.error.length > 0) {
      message = error?.error[0]?.userMessage;
    } else {
      message = error?.error?.userMessage ||  COMMON_CONSTANTS.SERVER_ERROR_MSG;
    }

    let config = {
      data: {
        title: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
        iconType: COMMON_CONSTANTS.ALERT_TYPES.WARNING,
        message: message,
        btnNo: false,
        class: {
          btnOk: COMMON_CONSTANTS.TEST,
        },
      }
    };
    this.alertModal.openModal(config).result.then((res: AlertPromiseResolveType) => undefined);
  }

  isSimSwapFeatureEnabled(oktaEnabled) {
    // Turn off feature for everyone if flag is not enabled
    if (!environment.ENABLE_SIM_SWAP_FEATURE ) {
      return environment.ENABLE_SIM_SWAP_FEATURE;
    }
    return oktaEnabled || environment.ENABLE_SIM_SWAP_IAM;
  }

  getMaxMinDates() {
    this.portInPSTDate = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
    let minimumDate = {};
    let maximumDate = {};
      const finalDate = this.portInPSTDate?.currentPstDate?.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      if (finalDate?.length) {
        minimumDate = {
          year: Number(finalDate[2]),
          month: Number(finalDate[0]),
          day: Number(finalDate[1]),
        };
      }
      const finalMaxDate = this.portInPSTDate?.portInMaxDate?.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);

      if (finalDate?.length) {
        maximumDate = {
          year: Number(finalMaxDate[2]),
          month: Number(finalMaxDate[0]),
          day: Number(finalMaxDate[1]),
        };
      }
      return [minimumDate, maximumDate];
  }

  validMobileNumberPattern(phoneNumber) {
    const reg = COMMON_CONSTANTS.USA_MSISDN_PATTERN_REGEX;
    phoneNumber = phoneNumber.trim().replace(/[^0-9]/g, '');
    let non_geo_pattern = COMMON_CONSTANTS.NON_GEO_REGEX;
    if(COMMON_CONSTANTS.NON_GEO__AREA_CODE.includes(phoneNumber.substring(0,3)) === false){
      return reg.test(phoneNumber);
    }else if (COMMON_CONSTANTS.NON_GEO__COUNTRY_CODE_EXCLUDES.includes(phoneNumber.substring(3,6)) === false){
      return non_geo_pattern.test(phoneNumber);
    }else{
      return false;
    }
  }

  enableStrategicPortIn() {
    // Set flag to false if feature not enabled or LH org
    if (!environment.ENABLE_STRATEGIC_PORT_IN || this._helperUtilSvc.isLhUser()) {
      return false;
    }
    // Check entitlement activity
    if(!this.bulkActivityEnabled("strategicPortIn")) {
      return false;
    }
    // Check org is a strategic port in org
    if (this.getLineIdentiferConfigResponse(BULK_UPLOAD.CONFIG_KEY_STRATEGIC_PORT_IN_ORG) != "true") {
      return false;
    }
    return true;
  }

  getLineIdentiferConfigResponse(configKey) {
    const config = JSON.parse(this._cacheSvc.getFromSessionStorage(LINE_IDENTIFIER.CONFIG_RESPONSE) || '{}');

    if (config?.orgConfigValues) {
      for (const item of config.orgConfigValues) {
        if (item?.configName == configKey) {
          return item?.configValue;
        }
      }
    }
  }

  bulkActivityEnabled(activityName) {
    let entitlementActivities = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ENTITLEMENT_ACTIVITIES);
    if (!isNullOrUndefined(entitlementActivities)) {
      entitlementActivities = JSON.parse(atob(entitlementActivities));
      return entitlementActivities?.bulk?.[activityName];
    }
    return false;
  }
}
